import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { PlayCircleIcon, TrendingUpIcon, LayoutGridIcon, ClockIcon, BookmarkIcon, CheckCircleIcon } from 'lucide-react';
interface VideoNavigationProps {
  activeTab: 'lessons' | 'educational' | 'saved' | 'completed';
}
export function VideoNavigation({
  activeTab
}: VideoNavigationProps) {
  const {
    isArabic
  } = useLanguage();
  const tabs = [{
    id: 'lessons',
    label: {
      en: 'Video Lessons',
      ar: 'دروس الفيديو'
    },
    icon: PlayCircleIcon,
    href: '/learn/video-lessons'
  }, {
    id: 'educational',
    label: {
      en: 'Educational Videos',
      ar: 'فيديوهات تعليمية'
    },
    icon: TrendingUpIcon,
    href: '/learn/educational-videos'
  }, {
    id: 'saved',
    label: {
      en: 'Saved',
      ar: 'المحفوظة'
    },
    icon: BookmarkIcon,
    href: '/learn/video-lessons/saved'
  }, {
    id: 'completed',
    label: {
      en: 'Completed',
      ar: 'المكتملة'
    },
    icon: CheckCircleIcon,
    href: '/learn/video-lessons/completed'
  }];
  return <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md mb-8" data-id="element-1629">
      <div className="flex flex-wrap" data-id="element-1630">
        {tabs.map(tab => <Link key={tab.id} to={tab.href} className={`flex items-center gap-2 px-4 py-3 ${activeTab === tab.id ? 'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400' : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700/50'} transition-colors`} data-id="element-1631">
            <tab.icon className="w-5 h-5" data-id="element-1632" />
            <span className="hidden sm:inline" data-id="element-1633">
              {isArabic ? tab.label.ar : tab.label.en}
            </span>
          </Link>)}
      </div>
    </div>;
}